<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 00em;">Chris started his career working on the floor in residential care as a night staffer, social worker, and supervisor. He formed a lifelong passion for the work.</p><br/>
<p style="text-indent: 00em;">After ten years he moved to the Public Prison Service, managing education, health and therapeutic programmes for the Wellington region’s three prisons, eventually managing Mount Crawford Prison.</p><br/>
<p style="text-indent: 00em;">Chris returned to the Welfare System to become Manager of Operations for the country’s Youth Justice Residences. He progressed to other senior roles in Youth Justice, eventually becoming the General Manager.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0d3babee